module.exports = __webpack_public_path__ + "static/media/1.0d133708.png";